<script setup lang="ts">
import {defineProps} from 'vue'
import UserAvatarComponent from './UserAvatarComponent.vue'
import {IResponseEntity} from '@toolify/server/src/services/EntityService/types/IResponseEntity'

interface Props {
  entity: IResponseEntity
}
const props = defineProps<Props>()
</script>

<template>
  <UserAvatarComponent :entity="entity"/>
</template>

<style scoped lang="scss">
@use '@toolify/client/src/styles/variables' as variables;

  .user-avatar {
    height: map-get(variables.$sizes, size-sm);
  }
</style>
